import { Component, OnInit } from "@angular/core";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { WorkoutService, AlertService, HttpService } from "../../../services";
import {
  WorkoutsState,
  TopBox,
  Fields,
  Store,
  Types,
  AutoUnsubscribe,
  Subscription,
  StorageUtil,
} from "../store";
import { InjuryService } from "../../../services/injury.service ";
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { AnimationKeyframesSequenceMetadata } from "@angular/core/src/animation/dsl";
import { notStrictEqual } from "assert";

@Component({
  selector: "app-team-injury-details",
  templateUrl: "./team-injury-details.component.html",
  styleUrls: ["./team-injury-details.component.css"],
})

@AutoUnsubscribe
export class TeamInjuryDetailsComponent implements OnInit {
  Editor = ClassicEditor;
  Editor2 = ClassicEditor;

  public teamID: number = 0;
  public playerID: number = 0;
  public injuryID: number = 0;

  public alphaNumericPattern = /^[a-zA-Z ]+$/;
  form: FormGroup;
  formData: any;

  public selectedInjuryLocation = "";

  public injuryDetails: any;
  public injuryNotes = [];
  public injuryDocuments = [];
  public injuryNoteOverview: any;


  public addInjuryNotePayload = {
    injurynoteID: 0,
    title: "",
    note: "",
    injuryID: 0,
    addedBy: 0,
  };

  public addInjuryDocumentPayload = {
    injurydocumentID: 0,
    title: "",
    documentURL: "",
    injuryID: 0,
    addedBy: 0,
  };

  public todayDateTime = new Date();
  public showVenueTypes: boolean = false;

  public links: { title: string; url: any }[] = [];

  constructor(
    private _service: InjuryService,
    private httpService: HttpService,
    private spinner: Ng4LoadingSpinnerService,
    private _alertService: AlertService,
    private activeRoute: ActivatedRoute,
    private fb: FormBuilder,
    private _router: Router
  ) {

    this.teamID = this.activeRoute.snapshot.params.teamID;
    this.playerID = this.activeRoute.snapshot.params.playerID;
    this.injuryID = this.activeRoute.snapshot.params.injuryID;

    this.buildForm();

    this.links = [
      { title: "TEAM PLAYERS LIST", url: "/team-injury/team-all-injuries" },
      { title: "PLAYER", url: `/team-injury/team-player-injuries/${this.teamID}/${this.playerID}` },
      { title: "INJURY DETAILS", url: null },
    ];
  }

  ngOnInit() {
    // 1. load Injury Informations
    // 2. load injury details

    this.loadInjuryInformations();
    // this.loadInjuryDetails(this.injuryID);

    this.popupConfirmForm = this.fb.group({
      confirm_discount_delete: [
        null,
        [Validators.required, Validators.pattern(this.alphaNumericPattern)],
      ],
    });
  }

  private buildForm() {
    this.form = this.fb.group({
      injuryclassificationID: [0, [Validators.required, Validators.min(1)]],
      injurylocationID: [0, [Validators.required, Validators.min(1)]],
      injuryoccuredID: [0, [Validators.required, Validators.min(1)]],
      injuryvenuetypeID: [0],
      injuryDate: [null, Validators.required],
      injuryRecoveryDate: [null, Validators.required],
      needSportsTrainer: [false, Validators.required],
      needDoctor: [false, Validators.required],
      injurystatusID: [0, [Validators.required, Validators.min(1)]],
      injurystatusOverview: [""],
      clubID: [0],
      teamID: [this.teamID],
      userID: [0],
      addedBy: +StorageUtil.userID
    });
  }

  loadInjuryInformations() {
    this.spinner.show();
    this._service.loadInjuryInformations().subscribe(
      (result) => {
        this.formData = result;
        //load injury details once information is ready
        this.loadInjuryDetails(this.injuryID);
        // this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  loadInjuryDetails(injuryID: number) {
    // this.spinner.show();
    this._service.loadInjuryDetails(injuryID).subscribe(
      (result: any) => {
        this.injuryDetails = result;
        this.injuryNotes = result.injuryNotes;
        this.injuryDocuments = result.injuryDocuments;
        this.injuryNoteOverview = result.injury.injuryoverview;
        this.setInjuryDetailsToForm(result.injury);
        this.setInjuryImage(this.formData, result.injury.injurylocationID);
        console.log("Injury Details ==> ", this.injuryDetails);
        this.spinner.hide();
      },
      (error) => {
        console.log("Error loading injury details....", error);
        this.spinner.hide();
      }
    );
  }

  setInjuryDetailsToForm(injury: any) {
    console.log("setInjuryDetailsToForm ==> injury ==> ", injury);
    this.form.patchValue({
      injuryclassificationID: injury.injuryclasificationID,
      injurylocationID: injury.injurylocationID,
      injuryoccuredID: injury.injuryoccuredID,
      injuryvenuetypeID: injury.injuryvenuetypeID,
      injuryDate: new Date(injury.injuryoccureddate),
      injuryRecoveryDate: new Date(injury.estrecoverydate), //moment(injury.estrecoverydate).format("MM/DD/YYYY"), //injury.estrecoverydate,
      needSportsTrainer: injury.needstoseesportstrainer,
      needDoctor: injury.needstoseedoctor,
      injurystatusID: injury.injurystatusID,
      injurystatusOverview: injury.injuryoverview,
      clubID: 0,
      teamID: this.teamID,
      userID: 0,
    });

    if(injury.injuryoccuredID == 1 || injury.injuryoccuredID == 2){
      this.showVenueTypes = true;
    } else {
      this.showVenueTypes = false;
    }
  }

  setInjuryImage(formData: any, injuryLocationID: number) {
    //  let injuryLocationID = this.form.value.injurylocationID;
    console.log("Selected injuryLocationID ==> ", injuryLocationID);
    let selectedLocation = this.formData.locations.find(
      (n) => n.injurylocationID == injuryLocationID
    );
    console.log("Selected location ==> ", selectedLocation);
    this.selectedInjuryLocation = selectedLocation.imageURL;
  }

  onInjuryLocationSelected(locationID) {
    let selectedLocation = this.formData.locations.find(
      (n) => n.injurylocationID == locationID
    );
    this.selectedInjuryLocation = selectedLocation.imageURL;
  }

  onInjuryOccuredSelected(value) {
    // 1 - During Practise
    // 2 - During Game
    // 3 - On Their Own
    // 4 - Other
    console.log("onInjuryOccuredSelected ===> ", value);

    if (value == 1 || value == 2) {
      this.showVenueTypes = true;
      //Set Venue Type ID Required
      this.form
        .get("injuryvenuetypeID")
        .setValidators([Validators.required, Validators.min(1)]);
    } else {
      //reset venue type
      this.showVenueTypes = false;
      //Set Venue Type ID Required to False
      this.form.get("injuryvenuetypeID").clearValidators();
      this.form.patchValue({ injuryvenuetypeID: 0 });
    }
  }

  onAddNoteToInjury() {
    this.addInjuryNotePayload.addedBy = +localStorage.getItem("userId");
    this.addInjuryNotePayload.injuryID = this.injuryID;
    console.log("Injury Note Payload ==> ", this.addInjuryNotePayload);
    this.spinner.show();

    this._service.addNoteToInjury(this.addInjuryNotePayload).subscribe(
      (result) => {
        // this.spinner.hide();
        this._alertService.success("Note added");
        this.resetAddNoteToInjuryPayload();
        this.loadInjuryDetails(this.injuryID);
      },
      (error) => {
        this.spinner.hide();
        this._alertService.error("Note could not be added");
      }
    );
  }

  onUpdateInjuryNote(injuryNote: any) {
    this.isShowAddNoteToInjury = true;
    this.addInjuryNotePayload.note = injuryNote.description;
    this.addInjuryNotePayload.title = injuryNote.title;
    this.addInjuryNotePayload.injurynoteID = injuryNote.injuryNoteID;
  }

  public isShowAddNoteToInjury = false;
  public isShowAddDocumentToInjury = false;
  addNoteToInjury() {
    this.isShowAddNoteToInjury = true;
  }

  addDocumentToInjury() {
    this.isShowAddDocumentToInjury = true;
  }

  onCancel() {
    this.resetAddNoteToInjuryPayload();
  }

  resetAddNoteToInjuryPayload() {
    this.isShowAddNoteToInjury = false;
    this.addInjuryNotePayload.note = "";
    this.addInjuryNotePayload.title = "";
    this.addInjuryNotePayload.injurynoteID = 0;
  }

  resetAddDocumentToInjuryPayload() {
    this.isShowAddDocumentToInjury = false;
    this.addInjuryDocumentPayload.documentURL = "";
    this.addInjuryDocumentPayload.title = "";
    this.addInjuryDocumentPayload.injurydocumentID = 0;
  }

  updatePlayerInjuryUpdate(event) {
    this.form.patchValue({ injurystatusOverview: this.injuryNoteOverview });
    this.spinner.show();
    console.log("updatePlayerInjury PAYLOAD ==> ", this.form.value);
    this._service.updatPlayerInjury(this.injuryID, this.form.value).subscribe(
      (result) => {
        this._alertService.success("Injury updated");
        this.loadInjuryDetails(this.injuryID);
      },
      (error) => {
        this.spinner.hide();
        this._alertService.error("Injury could not be updated");
      }
    );
  }

  public fileName = "";
  public fileToUpload: AnimationKeyframesSequenceMetadata;
  public dropZoneText = "Drop file here to upload";
  getUploadedFile(file) {
    if (file) {
      console.log("getUploadedFile ===> ", file);
      this.fileToUpload = file;
      this.fileName = file.name;
    }
  }
  cancelChangeUpload() {
    // this.changeUploadDoc = false;
    this.fileToUpload = undefined;
    this.fileName = undefined;
    // this.selectedAssocForm = undefined;
    this.dropZoneText = "Drop file here to upload";
  }

  public newUploadedFilePath = "";
  uploadInjuryDocument(event) {
    this.spinner.show();
    this.httpService
      .upload(
        "/api/player/UploadSingleFile/" + this.playerID,
        this.fileToUpload,
        this.fileName
      )
      .subscribe(
        (res) => {
          this.newUploadedFilePath = res[0]; // Uploaded File Path
          console.log(this.newUploadedFilePath);
          this.addInjuryDocumentPayload.addedBy = +localStorage.getItem(
            "userId"
          );
          this.addInjuryDocumentPayload.injuryID = this.injuryID;
          this.addInjuryDocumentPayload.documentURL = this.newUploadedFilePath;
          console.log(
            "Injury Document Payload ==> ",
            this.addInjuryNotePayload
          );
          this._service
            .addDocumentToInjury(this.addInjuryDocumentPayload)
            .subscribe(
              (result) => {
                this.resetAddDocumentToInjuryPayload();
                this.spinner.hide();
                this._alertService.success("Injury document added");
                this.loadInjuryDetails(this.injuryID);
              },
              (error) => {
                this.spinner.hide();
                this._alertService.error("Could not upload injury document");
              }
            );

          // resetAddDocumentToInjuryPayload
        },
        (error) => {
          this.spinner.hide();
          this._alertService.error("Could not upload injury document");
          console.log(error.error);
        }
      );
  }

  //REPLACE DOCUMENT START
  // public addInjuryDocumentPayload = {
  //   injurynoteID: 0,
  //   title: '',
  //   documentURL: '',
  //   injuryID: 0,
  //   addedBy: 0
  // };

  //   addedBy: "Patterson, Steve"
  // dateAdded: "2020-08-07T14:26:52"
  // documentURL: "https://s3.amazonaws.com/images.totalglobalsports.com/PlayerForm/Hailey_Whittaker_7d5ebcc7c8384856be33de4b613c11e6_imageuploa.PNG"
  // injuryDocumentID: 10
  // title: "Image Upload Test"

  updateInjuryDocument(event) {
    this.spinner.show();
    this.httpService
      .upload(
        "/api/player/UploadSingleFile/" + this.playerID,
        this.fileToUpload,
        this.fileName
      )
      .subscribe(
        (res) => {
          this.newUploadedFilePath = res[0]; // Uploaded File Path
          console.log(this.newUploadedFilePath);
          this.addInjuryDocumentPayload.documentURL = this.newUploadedFilePath;
          this._service
            .addDocumentToInjury(this.addInjuryDocumentPayload)
            .subscribe(
              (result) => {
                this.resetAddDocumentToInjuryPayload();
                this.spinner.hide();
                this._alertService.success("Injury document updated");
                this.loadInjuryDetails(this.injuryID);
              },
              (error) => {
                this.spinner.hide();
                this._alertService.error("Could not update injury document");
              }
            );

          // resetAddDocumentToInjuryPayload
        },
        (error) => {
          this.spinner.hide();
          this._alertService.error("Could not upload injury document");
          console.log(error.error);
        }
      );
  }

  onUpdateInjuryDocument(x) {
    //OPEN FLYOUT
    this.isShowAddDocumentToInjury = true;

    this.addInjuryDocumentPayload.injurydocumentID = x.injuryDocumentID;
    this.addInjuryDocumentPayload.title = x.title;
    this.addInjuryDocumentPayload.documentURL = x.documentURL;
    this.addInjuryDocumentPayload.injuryID = this.injuryID;
    this.addInjuryDocumentPayload.addedBy = -1;
  }

  //REPLACE DOCUMENT END

  //SHOW DOCUMENT
  public selectedDocumentTitle: string = "";
  public selectedDocumentURL: string = "";
  public selectedInjuryDocument: boolean = false;
  public formPreviewOpen: boolean = false;

  showInjuryDocument(document) {
    console.log("Injury Document ==> ", document);
    this.selectedDocumentTitle = document.title;
    this.selectedDocumentURL = document.documentURL;
    this.selectedInjuryDocument = true;
    this.formPreviewOpen = true;
  }
  //END SHOW DOCUMENT

  //DELETE NOTE: START
  // 0 - injuryNotes
  // 1 - injuryDocuments
  public selectedDeleteValue: number;
  onDeleteSelectedData(value) {
    this.selectedDeleteValue = value;
    this.openPopup();
  }
  public isOpenConfirmDeletePopup = false;
  public popupConfirmForm: FormGroup;

  openPopup() {
    this.isOpenConfirmDeletePopup = true;
  }
  closePopup() {
    this.removeValidation("confirm_discount_delete");
    this.isOpenConfirmDeletePopup = false;
  }

  onPopUpConfirm(formValue) {
    const flag = this.isDeleteTextMatched();
    if (flag) {
      this.closePopup();
      console.log("SELECTED FOR DELITION ===> ", this.selectedDeleteValue);
      // this.deleteSelectedInjuries();
      if (this.selectedDeleteValue === 0) {
        this.deleteSelectedInjuryNotes();
      } else {
        this.deleteSelectedInjuryDocuments();
      }
    }
  }
  removeValidation(name) {
    const control = this.popupConfirmForm.get(name);
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
  }
  isDeleteTextMatched() {
    const val = this.popupConfirmForm.get("confirm_discount_delete").value;
    if (val) {
      return val.trim() === "DELETE" ? true : false;
    }
  }
  isConfirmDeleteValid() {
    return (
      this.popupConfirmForm.get("confirm_discount_delete").errors &&
      (this.popupConfirmForm.get("confirm_discount_delete").touched ||
        this.popupConfirmForm.get("confirm_discount_delete").dirty)
    );
  }

  deleteSelectedInjuryNotes() {
    const injurynoteIDs = this.selectedInjuryNotes
      .map((a) => a.injuryNoteID)
      .join(",");
    this.spinner.show();
    this._service.removePlayerInjuryNotes(injurynoteIDs).subscribe(
      (data: any) => {
        this.injuryNotes.forEach((x) => (x.checked = false));
        this.removeValidation("confirm_discount_delete");
        this.closePopup();
        this.spinner.hide();
        this._alertService.success("Injury notes deleted");
        this.loadInjuryDetails(this.injuryID);
      },
      (error) => {
        console.log(error);
        this.spinner.hide();
        this._alertService.error("Could not delete selected notes");
      }
    );
  }

  deleteSelectedInjuryDocuments() {
    const injurydocumentIDs = this.selectedInjuryDocuments
      .map((a) => a.injuryDocumentID)
      .join(",");
    this.spinner.show();
    this._service.removePlayerInjuryDocuments(injurydocumentIDs).subscribe(
      (data: any) => {
        this.injuryNotes.forEach((x) => (x.checked = false));
        this.removeValidation("confirm_discount_delete");
        this.closePopup();
        this.spinner.hide();
        this._alertService.success("Injury documents deleted");
        this.loadInjuryDetails(this.injuryID);
      },
      (error) => {
        this.spinner.hide();
        this._alertService.error("Could not delete selected documents");
      }
    );
  }

  get allInjuryNotesChecked() {
    return (
      this.injuryNotes &&
      this.injuryNotes.length &&
      this.injuryNotes.every((p) => p.checked)
    );
  }

  set allInjuryNotesChecked(checked: boolean) {
    this.injuryNotes.forEach((x) => (x.checked = checked));
  }

  get selectedInjuryNotes() {
    return this.injuryNotes.filter((x) => x.checked);
  }
  //DELETE NOTE: END

  get allInjuryDocumentsChecked() {
    return (
      this.injuryDocuments &&
      this.injuryDocuments.length &&
      this.injuryDocuments.every((p) => p.checked)
    );
  }

  set allInjuryDocumentsChecked(checked: boolean) {
    this.injuryDocuments.forEach((x) => (x.checked = checked));
  }

  get selectedInjuryDocuments() {
    return this.injuryDocuments.filter((x) => x.checked);
  }

  get allChecked() {
    return (
      this.injuryDocuments &&
      this.injuryDocuments.length &&
      this.injuryDocuments.every((p) => p.checked)
    );
  }

  set allChecked(checked: boolean) {
    this.injuryDocuments.forEach((x) => (x.checked = checked));
  }

  closeOverlay(event) {
    this.isShowAddNoteToInjury = false;
    this.isShowAddDocumentToInjury = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/team-injuries/team-injury-details/team-injury-details.component.ts